export default "__VITE_ASSET__CDouAnU5__"